module.exports = __webpack_public_path__ + "static/media/dark_dataak_fav.f84d8c0b.png";